import React from 'react';
import TrackContent from '../function-components/TrackContent';

function Track() {
  return (
    <>
    <TrackContent />
    </>
  )
}

export default Track;